import { Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { FileDownloadService } from 'src/app/services/file-download-service/file-download.service';
import { ExamsService } from '../../services/exams.service';

@Component({
  selector: 'app-promotion-report',
  templateUrl: './promotion-report.component.html',
  styleUrls: ['./promotion-report.component.scss']
})
export class PromotionReportComponent extends ComponentBase implements OnInit {

  constructor(private examsService: ExamsService,
    private fileDownloadService: FileDownloadService) {
    super();
  }

  allowDownload: boolean = false;

  ngOnInit() {
    let sub = this.examsService.getPromotionReportViewStatus().subscribe(res => {
      this.allowDownload = res['status'];
    });
    this.addSubscription(sub);
  }

  downloadPromotionReport() {
    let sub = this.examsService.getExamPromotionReportCardUrl()
      .pipe(
        switchMap(res => {
          return this.fileDownloadService.downloadAndOpen(res['url'], "Promotion_Report.pdf", "application/pdf", true);
        })
      ).subscribe();
    this.addSubscription(sub);
  }

}
